/* FATCUTPRESS Current WebGL Visual Adapter
 * Maps Theme Editor visual keys to the current WebGL renderer.
 * Future independent renderers should use their own adapter files.
 */
(() => {
  'use strict';

  const adapter = window.FATCUT_CURRENT_WEBGL_ADAPTER;
  const registry = window.FATCUT_VISUAL_REGISTRY;
  if (!adapter || !registry) return;

  ['default', 'fog_greige', 'fog_black', 'fog_silver'].forEach(key => {
    registry.add(key, adapter);
  });
  registry.flush();
})();
